import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserEnum } from '@boels/models';
import { CartFacade, UserDataFacade } from '@boels/shared-state';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { ButtonComponent } from '../../button/button.component';

@Component({
  selector: 'boels-checkout-account-select',
  templateUrl: './checkout-account-select.component.html',
  styleUrls: ['./checkout-account-select.component.scss'],
  imports: [TranslocoModule, FontAwesomeModule, ButtonComponent],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['checkout'],
    },
  ],
})
export class CheckoutAccountSelectComponent {
  private userDataFacade: UserDataFacade = inject(UserDataFacade);
  private cartFacade: CartFacade = inject(CartFacade);
  private router: Router = inject(Router);

  protected readonly faLoginIcon = faRightToBracket;

  checkoutRequestLogin() {
    this.userDataFacade.requestLogin('/checkout/customer-details');
  }

  checkoutAsGuest() {
    this.cartFacade.setCheckoutAccount(UserEnum.GUEST);
    this.router.navigate(['/checkout/customer-details']);
  }
}
